var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticStyle: { padding: "10px", color: "#d9d9d9" } }, [
      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OcrTip")))
    ]),
    _vm.visible
      ? _c("div", { staticClass: "result-form-ae" }, [
          _c("div", { style: { cursor: "pointer", width: "100%" } }, [
            _c("div", { staticClass: "header-container" }, [
              _vm.showBookRecognitionResults
                ? _c(
                    "div",
                    { staticClass: "column-header recognition-header" },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("CargoMsg.Cargo_BookRecognitionResults")
                          )
                        )
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "toggle-button",
                          on: {
                            click: function($event) {
                              _vm.showBookRecognitionResults = false
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PackUp")))]
                      )
                    ]
                  )
                : _vm._e(),
              _c("div", { staticClass: "column-header business-header" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmedBusinessData")))
                ]),
                !_vm.showBookRecognitionResults
                  ? _c(
                      "span",
                      {
                        staticClass: "toggle-button",
                        on: {
                          click: function($event) {
                            _vm.showBookRecognitionResults = true
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ExpandAll")))]
                    )
                  : _vm._e()
              ])
            ]),
            _vm.currentOcrRecognitionFields &&
            _vm.currentOcrRecognitionFields.length > 0
              ? _c(
                  "div",
                  _vm._l(_vm.currentOcrRecognitionFields, function(item) {
                    return _c("div", { key: item.code }, [
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_CUSTOMER_ID.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c("div", { staticClass: "field-value" }, [
                                      _vm._v(_vm._s(_vm.resultJson[item.code]))
                                    ])
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("cargo-company-select", {
                                      class:
                                        !_vm.job.customerId &&
                                        _vm.resultJson[item.code] &&
                                        !_vm.resultJson[
                                          item.code + "_notShowPlaceholder"
                                        ]
                                          ? "color-red"
                                          : "",
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        )
                                      },
                                      attrs: {
                                        "method-params": {
                                          customer: true,
                                          companyLob: "airExport",
                                          active: true
                                        },
                                        "default-value":
                                          _vm.job.customerId || "",
                                        placeholder:
                                          !_vm.job.customerId &&
                                          _vm.resultJson[item.code] &&
                                          !_vm.resultJson[
                                            item.code + "_notShowPlaceholder"
                                          ]
                                            ? _vm.resultJson[item.code]
                                            : ""
                                      },
                                      on: {
                                        clear: function($event) {
                                          return _vm.clear(item)
                                        },
                                        change: function(p) {
                                          _vm.job.customerId = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_CARGO_TYPE.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c("div", { staticClass: "field-value" }, [
                                      _vm._v(_vm._s(_vm.resultJson[item.code]))
                                    ])
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("cargo-advance-select", {
                                      class:
                                        !_vm.job.cargoType &&
                                        _vm.resultJson[item.code] &&
                                        !_vm.resultJson[
                                          item.code + "_notShowPlaceholder"
                                        ]
                                          ? "color-red"
                                          : "",
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        )
                                      },
                                      attrs: {
                                        no: "cargoType",
                                        "select-type":
                                          _vm.selectTypeNames
                                            .basic_data_CargoType,
                                        "method-params": { air: true },
                                        filterable: "",
                                        clearable: "",
                                        placeholder:
                                          !_vm.job.cargoType &&
                                          _vm.resultJson[item.code] &&
                                          !_vm.resultJson[
                                            item.code + "_notShowPlaceholder"
                                          ]
                                            ? _vm.resultJson[item.code]
                                            : "",
                                        "default-value": _vm.job.cargoType
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.job.cargoType = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_SHIPPER.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "field-value field-value-textarea"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.resultJson[item.code])
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "field-value field-value-textarea"
                                  },
                                  [
                                    _c("el-input", {
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        )
                                      },
                                      attrs: { rows: 6, type: "textarea" },
                                      model: {
                                        value: _vm.job.shipper,
                                        callback: function($$v) {
                                          _vm.$set(_vm.job, "shipper", $$v)
                                        },
                                        expression: "job.shipper"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_CONSIGNEE.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "field-value field-value-textarea"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.resultJson[item.code])
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "field-value field-value-textarea"
                                  },
                                  [
                                    _c("el-input", {
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        )
                                      },
                                      attrs: { rows: 6, type: "textarea" },
                                      model: {
                                        value: _vm.job.consignee,
                                        callback: function($$v) {
                                          _vm.$set(_vm.job, "consignee", $$v)
                                        },
                                        expression: "job.consignee"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_NOTIFY.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "field-value field-value-textarea"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.resultJson[item.code])
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "field-value field-value-textarea"
                                  },
                                  [
                                    _c("el-input", {
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        )
                                      },
                                      attrs: { rows: 6, type: "textarea" },
                                      model: {
                                        value: _vm.job.notify,
                                        callback: function($$v) {
                                          _vm.$set(_vm.job, "notify", $$v)
                                        },
                                        expression: "job.notify"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_CARRIER.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c("div", { staticClass: "field-value" }, [
                                      _vm._v(_vm._s(_vm.resultJson[item.code]))
                                    ])
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("cargo-advance-select", {
                                      class:
                                        !_vm.job.carrierId &&
                                        _vm.resultJson[item.code] &&
                                        !_vm.resultJson[
                                          item.code + "_notShowPlaceholder"
                                        ]
                                          ? "color-red"
                                          : "",
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        )
                                      },
                                      attrs: {
                                        no: "41",
                                        filterable: "",
                                        "select-type":
                                          _vm.selectTypeNames
                                            .basic_data_Company,
                                        "method-params": {
                                          airCmp: true,
                                          companyLob: "airExport",
                                          active: true
                                        },
                                        "default-value":
                                          _vm.job.carrierId || "",
                                        headers: [
                                          _vm.$t("Tool.ShortName"),
                                          _vm.$t("Partners.chineseName")
                                        ],
                                        fields: ["shortName", "chineseName"],
                                        placeholder:
                                          !_vm.job.carrierId &&
                                          _vm.resultJson[item.code] &&
                                          !_vm.resultJson[
                                            item.code + "_notShowPlaceholder"
                                          ]
                                            ? _vm.resultJson[item.code]
                                            : ""
                                      },
                                      on: {
                                        clear: function($event) {
                                          return _vm.clear(item)
                                        },
                                        parentCallBack: function(p) {
                                          _vm.job.carrierId = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_VOYAGE.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c("div", { staticClass: "field-value" }, [
                                      _vm._v(_vm._s(_vm.resultJson[item.code]))
                                    ])
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input", {
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        )
                                      },
                                      on: {
                                        change: _vm.voyageFlightCheckHandler
                                      },
                                      model: {
                                        value: _vm.job.voyageFlight,
                                        callback: function($$v) {
                                          _vm.$set(_vm.job, "voyageFlight", $$v)
                                        },
                                        expression: "job.voyageFlight"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_LOADING_PORT_CODE.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c("div", { staticClass: "field-value" }, [
                                      _vm._v(_vm._s(_vm.resultJson[item.code]))
                                    ])
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("cargo-advance-select", {
                                      class:
                                        !_vm.job.loadingPortCode &&
                                        _vm.resultJson[item.code] &&
                                        !_vm.resultJson[
                                          item.code + "_notShowPlaceholder"
                                        ]
                                          ? "color-red"
                                          : "",
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        )
                                      },
                                      attrs: {
                                        no: "englishName",
                                        "select-type":
                                          _vm.selectTypeNames
                                            .basic_data_Airport,
                                        filterable: "",
                                        "default-value":
                                          _vm.job.loadingPortCode,
                                        "tag-name": "englishName",
                                        placeholder:
                                          !_vm.job.loadingPortCode &&
                                          _vm.resultJson[item.code] &&
                                          !_vm.resultJson[
                                            item.code + "_notShowPlaceholder"
                                          ]
                                            ? _vm.resultJson[item.code]
                                            : ""
                                      },
                                      on: {
                                        clear: function($event) {
                                          return _vm.clear(item)
                                        },
                                        parentCallBack: function(p) {
                                          _vm.job.loadingPortCode = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_DESTINATION_PORT_CODE.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c("div", { staticClass: "field-value" }, [
                                      _vm._v(_vm._s(_vm.resultJson[item.code]))
                                    ])
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("cargo-advance-select", {
                                      class:
                                        !_vm.job.destinationPortCode &&
                                        _vm.resultJson[item.code] &&
                                        !_vm.resultJson[
                                          item.code + "_notShowPlaceholder"
                                        ]
                                          ? "color-red"
                                          : "",
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        )
                                      },
                                      attrs: {
                                        no: "destinationPortCode",
                                        "select-type":
                                          _vm.selectTypeNames
                                            .basic_data_Airport,
                                        filterable: "",
                                        "default-value":
                                          _vm.job.destinationPortCode,
                                        placeholder:
                                          !_vm.job.destinationPortCode &&
                                          _vm.resultJson[item.code] &&
                                          !_vm.resultJson[
                                            item.code + "_notShowPlaceholder"
                                          ]
                                            ? _vm.resultJson[item.code]
                                            : ""
                                      },
                                      on: {
                                        clear: function($event) {
                                          return _vm.clear(item)
                                        },
                                        parentCallBack: function(p) {
                                          _vm.job.destinationPortCode = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_ETD.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c("div", { staticClass: "field-value" }, [
                                      _vm._v(_vm._s(_vm.resultJson[item.code]))
                                    ])
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-date-picker", {
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        )
                                      },
                                      attrs: {
                                        value: _vm.job.etd,
                                        type: "datetime",
                                        "value-format": "yyyy-MM-dd HH:mm",
                                        format: "yyyy-MM-dd HH:mm"
                                      },
                                      on: {
                                        input: _vm.etdChange,
                                        blur: function() {
                                          _vm.handleBlur(
                                            "etd",
                                            _vm.etdChange,
                                            false,
                                            false,
                                            _vm.job
                                          )
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_LOADING_TERM.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c("div", { staticClass: "field-value" }, [
                                      _vm._v(_vm._s(_vm.resultJson[item.code]))
                                    ])
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("cargo-advance-select", {
                                      class:
                                        !_vm.job.loadingTerm &&
                                        _vm.resultJson[item.code] &&
                                        !_vm.resultJson[
                                          item.code + "_notShowPlaceholder"
                                        ]
                                          ? "color-red"
                                          : "",
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        )
                                      },
                                      attrs: {
                                        no: "33",
                                        "select-type":
                                          _vm.selectTypeNames
                                            .local_cache_AirExportConstants$SUFFY_TYPES,
                                        filterable: "",
                                        clearable: "",
                                        "default-value": _vm.job.loadingTerm,
                                        placeholder:
                                          !_vm.job.loadingTerm &&
                                          _vm.resultJson[item.code] &&
                                          !_vm.resultJson[
                                            item.code + "_notShowPlaceholder"
                                          ]
                                            ? _vm.resultJson[item.code]
                                            : "",
                                        "callback-method-type": "value",
                                        fields: ["chineseName"],
                                        "tag-name": _vm.isZh
                                          ? "chineseName"
                                          : "englishName",
                                        "callback-params": {
                                          key: "loadingTerm"
                                        }
                                      },
                                      on: {
                                        parentCallBack: _vm.setJobSelectValue
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_LOADING_DATE.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c("div", { staticClass: "field-value" }, [
                                      _vm._v(_vm._s(_vm.resultJson[item.code]))
                                    ])
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-date-picker", {
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        )
                                      },
                                      attrs: {
                                        clearable: "",
                                        type: "datetime",
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        format: "yyyy-MM-dd HH:mm"
                                      },
                                      model: {
                                        value: _vm.job.trucking[0].loadingDate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job.trucking[0],
                                            "loadingDate",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "job.trucking[0].loadingDate"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_DOOR_ADDR.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c("div", { staticClass: "field-value" }, [
                                      _vm._v(_vm._s(_vm.resultJson[item.code]))
                                    ])
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input", {
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        )
                                      },
                                      model: {
                                        value: _vm.job.trucking[0].doorAddr,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job.trucking[0],
                                            "doorAddr",
                                            $$v
                                          )
                                        },
                                        expression: "job.trucking[0].doorAddr"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_DOOR_MAN.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c("div", { staticClass: "field-value" }, [
                                      _vm._v(_vm._s(_vm.resultJson[item.code]))
                                    ])
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input", {
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        )
                                      },
                                      model: {
                                        value: _vm.job.trucking[0].doorMan,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job.trucking[0],
                                            "doorMan",
                                            $$v
                                          )
                                        },
                                        expression: "job.trucking[0].doorMan"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_DRIVER_TEL.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c("div", { staticClass: "field-value" }, [
                                      _vm._v(_vm._s(_vm.resultJson[item.code]))
                                    ])
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input", {
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        )
                                      },
                                      model: {
                                        value: _vm.job.trucking[0].driverTel,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job.trucking[0],
                                            "driverTel",
                                            $$v
                                          )
                                        },
                                        expression: "job.trucking[0].driverTel"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_PAYMENT_TERM.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c("div", { staticClass: "field-value" }, [
                                      _vm._v(_vm._s(_vm.resultJson[item.code]))
                                    ])
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("cargo-advance-select", {
                                      class:
                                        !_vm.job.paymentTermMBL &&
                                        _vm.resultJson[item.code] &&
                                        !_vm.resultJson[
                                          item.code + "_notShowPlaceholder"
                                        ]
                                          ? "color-red"
                                          : "",
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        )
                                      },
                                      attrs: {
                                        "select-type":
                                          _vm.selectTypeNames
                                            .basic_data_PaymentTerm,
                                        filterable: "",
                                        clearable: "",
                                        "default-value": _vm.job.paymentTermMBL,
                                        placeholder:
                                          !_vm.job.paymentTermMBL &&
                                          _vm.resultJson[item.code] &&
                                          !_vm.resultJson[
                                            item.code + "_notShowPlaceholder"
                                          ]
                                            ? _vm.resultJson[item.code]
                                            : ""
                                      },
                                      on: {
                                        clear: function($event) {
                                          return _vm.clear(item)
                                        },
                                        parentCallBack: function(p) {
                                          _vm.job.paymentTermMBL = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_INCO_TERM.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c("div", { staticClass: "field-value" }, [
                                      _vm._v(_vm._s(_vm.resultJson[item.code]))
                                    ])
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("cargo-advance-select", {
                                      class:
                                        !_vm.job.incoTerm &&
                                        _vm.resultJson[item.code] &&
                                        !_vm.resultJson[
                                          item.code + "_notShowPlaceholder"
                                        ]
                                          ? "color-red"
                                          : "",
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        )
                                      },
                                      attrs: {
                                        no: "incoTerm",
                                        "select-type":
                                          _vm.selectTypeNames
                                            .basic_data_IncoTerm,
                                        filterable: "",
                                        clearable: "",
                                        "default-value": _vm.job.incoTerm,
                                        placeholder:
                                          !_vm.job.incoTerm &&
                                          _vm.resultJson[item.code] &&
                                          !_vm.resultJson[
                                            item.code + "_notShowPlaceholder"
                                          ]
                                            ? _vm.resultJson[item.code]
                                            : ""
                                      },
                                      on: {
                                        clear: function($event) {
                                          return _vm.clear(item)
                                        },
                                        parentCallBack: function(p) {
                                          _vm.job.incoTerm = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_QUANTITY.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c("div", { staticClass: "field-value" }, [
                                      _vm._v(_vm._s(_vm.resultJson[item.code]))
                                    ])
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input-number", {
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        ),
                                        textAlign: "left"
                                      },
                                      attrs: {
                                        controls: false,
                                        no: "quantityContract"
                                      },
                                      model: {
                                        value: _vm.job.quantityContract,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "quantityContract",
                                            $$v
                                          )
                                        },
                                        expression: "job.quantityContract"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_PACKING.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c("div", { staticClass: "field-value" }, [
                                      _vm._v(_vm._s(_vm.resultJson[item.code]))
                                    ])
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("cargo-packing-select", {
                                      class:
                                        !_vm.job.packing &&
                                        _vm.resultJson[item.code] &&
                                        !_vm.resultJson[
                                          item.code + "_notShowPlaceholder"
                                        ]
                                          ? "color-red"
                                          : "",
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        )
                                      },
                                      attrs: {
                                        no: "packing",
                                        "default-value": _vm.job.packing,
                                        placeholder:
                                          !_vm.job.packing &&
                                          _vm.resultJson[item.code] &&
                                          !_vm.resultJson[
                                            item.code + "_notShowPlaceholder"
                                          ]
                                            ? _vm.resultJson[item.code]
                                            : ""
                                      },
                                      on: {
                                        clear: function($event) {
                                          return _vm.clear(item)
                                        },
                                        change: function(p) {
                                          _vm.job.packing = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_GROSS_WEIGHT.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c("div", { staticClass: "field-value" }, [
                                      _vm._v(_vm._s(_vm.resultJson[item.code]))
                                    ])
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input-number", {
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        ),
                                        textAlign: "left"
                                      },
                                      attrs: {
                                        precision: 3,
                                        controls: false,
                                        no: "weightContract"
                                      },
                                      model: {
                                        value: _vm.job.weightContract,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "weightContract",
                                            $$v
                                          )
                                        },
                                        expression: "job.weightContract"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_CUBAGE.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c("div", { staticClass: "field-value" }, [
                                      _vm._v(_vm._s(_vm.resultJson[item.code]))
                                    ])
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("el-input-number", {
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        ),
                                        textAlign: "left"
                                      },
                                      attrs: {
                                        precision: 3,
                                        controls: false,
                                        no: "cubageContract"
                                      },
                                      model: {
                                        value: _vm.job.cubageContract,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "cubageContract",
                                            $$v
                                          )
                                        },
                                        expression: "job.cubageContract"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_MARK.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "field-value field-value-textarea"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.resultJson[item.code])
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "field-value field-value-textarea"
                                  },
                                  [
                                    _c("el-input", {
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        )
                                      },
                                      attrs: {
                                        rows: 6,
                                        type: "textarea",
                                        no: "mark"
                                      },
                                      model: {
                                        value: _vm.job.mark,
                                        callback: function($$v) {
                                          _vm.$set(_vm.job, "mark", $$v)
                                        },
                                        expression: "job.mark"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_GOOD_NAME.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "field-value field-value-textarea"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.resultJson[item.code])
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "field-value field-value-textarea"
                                  },
                                  [
                                    _c("el-input", {
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        )
                                      },
                                      attrs: {
                                        rows: 6,
                                        type: "textarea",
                                        no: "cargoEnglishName"
                                      },
                                      model: {
                                        value: _vm.job.cargoEnglishName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "cargoEnglishName",
                                            $$v
                                          )
                                        },
                                        expression: "job.cargoEnglishName"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_MEASUREMENTS.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "field-value field-value-textarea"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.resultJson[item.code])
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "field-value field-value-textarea"
                                  },
                                  [
                                    _c("el-input", {
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        )
                                      },
                                      attrs: {
                                        rows: 6,
                                        type: "textarea",
                                        no: "measurements"
                                      },
                                      model: {
                                        value: _vm.job.measurements,
                                        callback: function($$v) {
                                          _vm.$set(_vm.job, "measurements", $$v)
                                        },
                                        expression: "job.measurements"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_CHARGEWEIGHT.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c("div", { staticClass: "field-value" }, [
                                      _vm._v(_vm._s(_vm.resultJson[item.code]))
                                    ])
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "field-value" },
                                  [
                                    _c("auto-number-input", {
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        )
                                      },
                                      attrs: {
                                        no: "chargeWeight",
                                        precision: 3,
                                        min: 0
                                      },
                                      on: {
                                        valCallBack: function(val) {
                                          _vm.job.chargeWeight = val
                                        }
                                      },
                                      model: {
                                        value: _vm.job.chargeWeight,
                                        callback: function($$v) {
                                          _vm.$set(_vm.job, "chargeWeight", $$v)
                                        },
                                        expression: "job.chargeWeight"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_REMARKS.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-label",
                                        style: {
                                          color: _vm.getFieldColor(item)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.OcrUtils.getOcrFieldLabel(
                                              item.code,
                                              _vm.useCase
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "field-value field-value-textarea"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.resultJson[item.code])
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "item3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-label",
                                    style: { color: _vm.getFieldColor(item) }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.OcrUtils.getOcrFieldLabel(
                                          item.code,
                                          _vm.useCase
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "field-value field-value-textarea"
                                  },
                                  [
                                    _c("el-input", {
                                      style: {
                                        borderColor: _vm.getValueBorderColor(
                                          item
                                        )
                                      },
                                      attrs: {
                                        rows: 6,
                                        type: "textarea",
                                        no: "remarks"
                                      },
                                      model: {
                                        value: _vm.job.remarks,
                                        callback: function($$v) {
                                          _vm.$set(_vm.job, "remarks", $$v)
                                        },
                                        expression: "job.remarks"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ])
                  }),
                  0
                )
              : _vm._e()
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }